import { Injectable } from '@angular/core';
import { OutcomeAction } from '../models/outcomes/OutcomeAction';
import { ValidationService } from './validation.service';
import { LoadingController } from '@ionic/angular';
import { ApiOutcomeActionsService } from '../api-services/outcome-actions.api.service';

@Injectable({
  providedIn: 'root'
})
export class OutcomeActionService {
  
  constructor(
    public outcomeActionApi: ApiOutcomeActionsService,
    public validationService: ValidationService,
    public loadingController: LoadingController
  ) { }

  
  async addOutcomesAction(action: OutcomeAction) {
    return new Promise<void>((resolve) => {
      this.outcomeActionApi.addOutcomeAction(action).subscribe(res1 => {
        resolve();
      });
    });
  }

  async removeOutcomeAction(id: number) {
    return new Promise<void>((resolve) => {
      this.outcomeActionApi.deleteOutcomeAction(id).subscribe(res1 => {
        resolve();
      });
    });
  }

  async getOutcomeActions() {
    return new Promise<void>((resolve) => {
      this.outcomeActionApi.getOutcomeActions().subscribe(res1 => {
        resolve();
      });
    });
  }

  async getOutcomeAction(id: number) {
    return new Promise<void>((resolve) => {
      this.outcomeActionApi.getOutcomeAction(id).subscribe(res1 => {
        resolve();
      });
    });
  }

  getOutcomeActionBySceneId(id:number){
    return new Promise<OutcomeAction[]>((resolve) => {
      this.outcomeActionApi.getOutcomeActionBySceneId(id).subscribe(res1 => {
        resolve(res1);
      });
    }); 
  }

  async getOutcomeActionBySceneAssetRelationId(id:number){
    return new Promise<OutcomeAction[]>((resolve) => {
      this.outcomeActionApi.getOutcomeActionBySceneAssetRelationId(id).subscribe(res1 => {
        resolve(res1);
      });
    }); 
  }
}